import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import toast from "react-hot-toast";

const ChangeLicenceModal = ({ showChangeLicenceModal, expireDate, toggle }) => {
  const [licenseKey, setLicenseKey] = useState("");

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  useEffect(() => {
    if (userDetails?.cid && showChangeLicenceModal) {
      axios({
        method: "GET",
        url: `${baseUrl}/license/customer/${userDetails?.cid}/get`,
        headers: {
          Authorization: token,
        },
      })
        .then((res) => {
          let data = res.data.data;
          setLicenseKey(data);
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
          } else {
            toast.remove();
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
          }
        });
    }
  }, [showChangeLicenceModal]);

  const updateLicenseKey = () => {
    if (licenseKey === "") {
      toast.error("License cannot be empty", {
        position: "bottom-center",
      });
    } else {
      axios({
        method: "POST",
        url: `${baseUrl}/license/update`,
        headers: {
          Authorization: token,
        },
        data: {
          license: licenseKey,
        },
      })
        .then((res) => {
          toast.success("Licence Key updated successfully", {
            position: "bottom-center",
          });
          toggle();
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
          } else {
            toast.remove();
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
          }
        });
    }
  };

  return showChangeLicenceModal ? (
    <div
      className={`modal fade d-block show modal-container`}
      id="category-modal"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Change Licence
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                toggle();
              }}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <div>
              <p className="input-field-side-text float-left mb-2">
                Enter the new license key
              </p>
              <div className="">
                <textarea
                  rows={8}
                  className="form-control no-resize"
                  value={licenseKey}
                  style={{ resize: "none" }}
                  onChange={(e) => setLicenseKey(e.target.value)}
                />
              </div>
            </div>
            <div>
              <p className="input-field-side-text float-left mt-4 mb-2">
                Expires in:{" "}
                <span
                  className={`p-0 m-0 ${
                    expireDate === "PERPETUAL LICENCE"
                      ? "text-success"
                      : "text-warning"
                  }`}
                >
                  {expireDate}
                </span>
              </p>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                toggle();
              }}
            >
              Cancel
            </button>

            <Button
              // loading={buttonLoader}
              type="button"
              className="btn btn-primary"
              onClick={() => {
                updateLicenseKey();
              }}
            >
              Save changes
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default ChangeLicenceModal;
